/**
 * Feature flags do Six Pass.
 *
 * Avaliadas em build time via Vite. Para ativar/desativar uma feature em um
 * ambiente, defina a env var correspondente no `.env.local` (dev) ou no
 * provedor de hosting (prod).
 */

/** Lê uma env var Vite. */
function readEnv(viteName: string): string {
  const viteEnv = (import.meta as ImportMeta & { env?: Record<string, string | undefined> }).env;
  return viteEnv?.[viteName] ?? '';
}

const SIXY_DISABLED = readEnv('VITE_SIXY_AI_DISABLED');
const SENTRY_DSN = readEnv('VITE_SENTRY_DSN');

/**
 * Sixy AI usa Edge Function `gemini-proxy` (Supabase) — a API key fica como
 * secret no servidor, não no client. Habilitada por padrão; pra desligar
 * temporariamente, set `VITE_SIXY_AI_DISABLED=1` nas env vars.
 */
export const isSixyAIEnabled = (): boolean => SIXY_DISABLED !== '1';

/** Sentry só é inicializado se DSN estiver configurado. */
export const isSentryEnabled = (): boolean => SENTRY_DSN.length > 0;

/** Versão visível do app (para rodapés e logs). */
export const APP_VERSION = readEnv('VITE_APP_VERSION') || '1.0.17';
